import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Text from '@rsos/base-components/Text';
import { GOOGLE } from '@rsos/maps/constants/mapProviders';
import { createWebMercatorViewport } from '../../utils';
import { StyledPopoverCaret, StyledPopover } from './W3WPopover.styles';

const W3WPopover = ({ overlay }) => {
  const [popoverPosition, setPopoverPosition] = useState(null);
  const [popoverData, setPopoverData] = useState(null);
  const mapProvider = useSelector(state => state.sinatra.ui.mapProvider);
  const basemap = useSelector(state => state.sinatra.ui.basemap);
  const w3wPopover = useSelector(state => state.mapPopover.w3wPopover);

  const coordinates = useMemo(
    () => popoverData?.data?.coordinates,
    [popoverData],
  );

  /**
   * Repositions the popover based on the current viewState.
   * @param {Object} viewState
   */
  const reposition = useCallback(
    (viewState, w3wPopover) => {
      const viewport = createWebMercatorViewport(viewState, basemap);
      if (w3wPopover?.coordinates) {
        const location = [
          w3wPopover.coordinates.lng,
          w3wPopover.coordinates.lat,
        ];
        const [x, y] = viewport.project(location);
        setPopoverData({
          data: w3wPopover,
          x,
          y,
        });
        setPopoverPosition({ x, y });
      }
    },
    [setPopoverPosition, basemap],
  );

  // Reposition whenever the popover data changes.
  useEffect(() => {
    if (overlay && w3wPopover) {
      const viewState = overlay.getViewState();
      reposition(viewState, w3wPopover);
    }

    if (!w3wPopover) {
      setPopoverPosition(null);
      setPopoverData(null);
    }
  }, [overlay, w3wPopover, reposition]);

  return (
    <>
      {mapProvider === GOOGLE && popoverPosition && popoverData && (
        <StyledPopover x={popoverPosition?.x} y={popoverPosition?.y}>
          <Text>w3w</Text>
          <Text>
            {coordinates.lat}, {coordinates.lng}
          </Text>
          <StyledPopoverCaret />
        </StyledPopover>
      )}
    </>
  );
};

export default W3WPopover;
